import type { AssetRopaDpiaFilterFields } from 'config/api/assetRopa/assetRopaDpiaFilters';
import { DEFAULT_ASSET_ROPA_DPIA_FILTER_FIELDS } from 'config/api/assetRopa/assetRopaDpiaFilters';
import type { ProcessingActivityEditorCategory } from 'pages/ProcessingActivities/ProcessingActivityEditorPage/processingActivityEditor.types';

export type ProcessingActivityChangelogEntry = {
  versionNumber: number;
  publishedAt: string;
  publishedByDisplayName: string;
  changeComment: string;
};

export type ProcessingActivityDetailPurpose = {
  id?: number;
  purposeText: string;
  legalBasis: string;
  legalBasisComment: string;
  retentionDescription: string;
  liaRequired: boolean;
  isDeleted: boolean;
};

export type ProcessingActivityDetailViewModel = {
  categories: {
    dataSubjectCategories: ProcessingActivityEditorCategory[];
    personalDataCategories: ProcessingActivityEditorCategory[];
    recipientCategories: ProcessingActivityEditorCategory[];
  };
  changelog: ProcessingActivityChangelogEntry[];
  purposes: ProcessingActivityDetailPurpose[];
};

export type AssetProcessingActivityTableSort = {
  direction: 'asc' | 'desc' | null;
  key: string | null;
};

export type AssetProcessingActivityTableFilters = AssetRopaDpiaFilterFields & {
  hasSensitivePersonalData: string;
  officialReviewStatus: string;
};

export const DEFAULT_ASSET_PROCESSING_ACTIVITY_TABLE_FILTERS: AssetProcessingActivityTableFilters = {
  officialReviewStatus: '',
  hasSensitivePersonalData: '',
  ...DEFAULT_ASSET_ROPA_DPIA_FILTER_FIELDS,
};

export const DEFAULT_ASSET_PROCESSING_ACTIVITY_TABLE_SORT: AssetProcessingActivityTableSort = {
  key: null,
  direction: null,
};
